/**
 * Mobile slide-over drawer wrapping the Sidebar. Backdrop click
 * closes; Esc key closes.
 */

import { useEffect } from "react";
import type { ReactNode } from "react";

interface DrawerProps {
  open: boolean;
  onClose(): void;
  children: ReactNode;
}

export function Drawer({ open, onClose, children }: DrawerProps): JSX.Element {
  useEffect(() => {
    if (!open) return;
    const handler = (event: KeyboardEvent): void => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  return (
    <>
      <div
        className={"vz-drawer-bg" + (open ? " open" : "")}
        onClick={onClose}
        aria-hidden
      />
      <aside
        className={"vz-drawer" + (open ? " open" : "")}
        aria-hidden={!open}
      >
        {children}
      </aside>
    </>
  );
}
